// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupDataForm_container__Vuf3B","form":"GroupDataForm_form__56cKB"};